module.exports = __webpack_public_path__ + "launched-app.svg?b886f0fe1b3b622c59243cf7100af5f4";